import { render } from "./RegistCode.vue?vue&type=template&id=e24f5dbe&scoped=true"
import script from "./RegistCode.vue?vue&type=script&lang=js"
export * from "./RegistCode.vue?vue&type=script&lang=js"

import "./RegistCode.vue?vue&type=style&index=0&id=e24f5dbe&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24f5dbe"]])

export default __exports__